import React,{useState,useEffect, forwardRef,useRef} from 'react';
import './editble_table.css'
import { useDispatch } from 'react-redux';
import delete_icon from '../../../assets/reUsableTemplates_assets/delete_icon.png';
import download_icon from '../../../assets/reUsableTemplates_assets/dowload_icon.png';
import selected_icon from '../../../assets/reUsableTemplates_assets/selected_icon.png';
import action_icon from "../../../assets/audit_assets/Audit_reusable_table/action.png"
import slno_icon from "../../../assets/audit_assets/Audit_reusable_table/sl_no.png"
import table_delete_icon from "../../../assets/reUsableTemplates_assets/table_delete_icon.png"
import table_edit_icon from "../../../assets/reUsableTemplates_assets/table_edit_icon.png"
import arrow_up from "../../../assets/audit_assets/Audit_reusable_table/arrow_up.png"
import arrow_down from "../../../assets/audit_assets/Audit_reusable_table/arrow_down.png"
import { globalDownloadAllSelectedIDsRecords } from '../../../services/global_redux/globale_actions/Download.action';  
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import Slide from '@mui/material/Slide';
import { use } from 'react';

const Transition = forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
  });
function Editble_table({mainIcon,mainIconColor,tableHeaderColor,tableHeaderTextColor, title ,header, data ,setEditableRow, setEditedValues, editedValues, handledeleteClickOpenalert, editableRow, setLoading ,useHolidays, getEditPermission ,getDeletePermission, date,handleSaveClick ,submitdelete,showSnackbar ,createOrfilterComp,actionClass,clientName,clientId,setCreateSingleAuditView,filterAuditForm,getCreatePermission,actionChecked,setActionChecked}) {
    const [checkDelete, setCheckDelete] = useState(getDeletePermission);
  const [deletesingleID, setdeletesingleID] = useState({});
  const [checkEdit, setCheckEdit] = useState(getEditPermission);
  const [selectedClient, setSelectedClient] = useState('');
  const [opendeletealert, setopendeletealert] = useState(false);
  const [checkedItems, setCheckedItems] = useState({});
  const [openeditalert, setOpeneditalert] = useState(false);
  const dispatch = useDispatch();
  const [permissionsAction, setPermissionsAction] = useState(null);
  const [stateData,setStateData]=useState(null)
  const [opendeletemultialert, setopendeletemultialert] = useState(false);
  const [checkedItemCount, setCheckedItemCount] = useState(0);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
  const [currentPage, setCurrentPage] = useState(1);
  const [recordsPerPage, setRecordsPerPage] = useState(10);
  const [currentMonthIssame, setCurrentMonthIssame] = useState(false);
  const [isAllChecked, setIsAllChecked] = useState(false);
  const containerRef = useRef(null);
    const [isScrollable, setIsScrollable] = useState(false);
    const [showTooltip, setShowTooltip] = useState(false);
    const [desabledMsg, setDesabledMsg] = useState(false);
    const [searchQuery, setSearchQuery] = useState("");
    const handleSort = (key) => {
      setSortConfig((prev) => ({
          key,
          direction: prev.key === key && prev.direction === "asc" ? "desc" : "asc",
      }));
  };
  useEffect(() => { 
    setCheckEdit(getEditPermission);
    setCheckDelete(getDeletePermission);
  }, [getEditPermission, getDeletePermission]);
  const getSortIcon = (key) => {
      if (sortConfig.key !== key) return "";
      return sortConfig.direction === "asc" ? arrow_up : arrow_down;
  };
  // useEffect(() => { 
  //   setCurrentPage(1);  
  // }, [data]);
  const filteredData = Array.isArray(data)
  ? data.filter(item =>
      Object.values(item).some(value =>
        String(value).toLowerCase().includes(searchQuery.toLowerCase())
      )
    )
  : [];
  const sortedData = [...filteredData].sort((a, b) => {
    if (!sortConfig.key) return 0;
    const aVal = a[sortConfig.key];
    const bVal = b[sortConfig.key];
    if (aVal < bVal) return sortConfig.direction === "asc" ? -1 : 1;
    if (aVal > bVal) return sortConfig.direction === "asc" ? 1 : -1;
    return 0;
  });
  
  // pagination
  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
  const currentRecords = sortedData.slice(indexOfFirstRecord, indexOfLastRecord);
  const totalPages = Math.ceil(sortedData.length / recordsPerPage);
  const current_month = date;
  const handlePageChange = (pageNumber) => {
      if (pageNumber >= 1 && pageNumber <= totalPages) {
          setCurrentPage(pageNumber);
      }
  };
  const getPageSizeOptions = (totalEntries) => {
    const options = [ 10, 20, 50, 100,200,300,400,500,600,];
    const filtered = options.filter(size => size < totalEntries);
  
    return [...filtered, totalEntries];
  };
   useEffect(()=>{
      if(actionChecked === "create"){
        if(totalPages === 0){
          setCurrentPage(totalPages);
        }else{
          setCurrentPage(totalPages);
        setActionChecked("");
        }
  
      }else if(actionChecked === "delete"){
        if(currentPage != 1 && currentPage > totalPages){
          setCurrentPage(totalPages);
        setActionChecked("");
        }
      }else{
        setActionChecked("");
      }
    },[actionChecked,totalPages])

  
const handleEditClick = (id) => {
    const item = data.find(d => d.id === id);
    setEditableRow(id);
    setEditedValues({ ...item });
  };
  const handleCancelClick = () => {
      setEditableRow(null);
      setEditedValues({});
  };

  
// delete

const handledeletealert = (id) => {
    setopendeletealert(true)
    setdeletesingleID(id)
  }
  const handledeleteClickconfirmed = () => {
      setopendeletealert(false)
      handledeleteClickOpenalert(deletesingleID)
  }
  const handledeleteClosealert = () => {
      setopendeletealert(false)
  }

  const handleCheckChange = (id) => {
    setCheckedItems(prevCheckedItems => ({
        ...prevCheckedItems,
        [id]: !prevCheckedItems[id]
    }));
  };
  
  const handledeletemultiClosealert = () => {
    setopendeletemultialert(false)
    setCheckedItems({})
  }
  const selectedDelete = (e) => {
    e.preventDefault();
    const selectedIds = Object.keys(checkedItems).filter(id => checkedItems[Number(id)]).map(id => Number(id));
    setopendeletemultialert(false)
    const selectedid = { ids: selectedIds };
    submitdelete(selectedid);
  };
  
  useEffect(() => {
    setCheckedItems({})
  }, [data]);
  
  function formatDate(dateString) {
    const date = new Date(dateString);
  
    if (isNaN(date.getTime())) {
        return dateString;
    }
  
    const options = { day: '2-digit', month: 'short', year: 'numeric' };
    return new Intl.DateTimeFormat('en-GB', options).format(date).replace(/ /g, '-');
  }
  function formatDateForInput(dateString) {
    // Try to create a Date object from the provided date string
    const date = new Date(dateString);
  
    // Check if the date is invalid
    if (isNaN(date.getTime())) {
        console.error("Invalid date string:", dateString);
        return null; // or handle the error as needed
    }
  
    return date.toISOString().split('T')[0];
  }
  
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    const trimmedValue = value.replace(/^\s+/, "");
    setEditedValues({
        ...editedValues,
        [name]: trimmedValue,
    });
  };
  const handleKeyDown = (e) => {
    if (e.key === " " && e.target.value.length === 0) {
      e.preventDefault();
    }
  };
  const handleCloseeditalert = () => {
      setOpeneditalert(false);
      setEditableRow(null);
      setEditedValues({});
  };
  
  const handleSaveClickconfirmed = () => {
    setOpeneditalert(false)
    handleSaveClick()
  }
  const handleSavealert = () => {
    setOpeneditalert(true)
  }
  
const renderCell = (item, headerItem) => {
    const isEditing = editableRow === item.id;
    const value = item[headerItem.key];
    let content;
    if (headerItem.input === "date") {
      content = isEditing ? (
        <input
          type="date"
          name={headerItem.key}
          value={formatDateForInput(editedValues[headerItem.key] || value)}
          onChange={handleInputChange}
          onKeyDown={handleKeyDown}
          readOnly={headerItem.readOnly}
        />
      ) : formatDate(value);
    }
    else if (headerItem.key === "status") {
      if (isEditing) {
        content = (
          <select
            name={headerItem.key}
            value={editedValues[headerItem.key] || ""}
            onChange={handleInputChange}
          >
            <option value="" disabled>--select--</option>
            <option value="Active">Active</option>
            <option value="In-active">In-active</option>
          </select>
        );
      } else {
        content = value;
      }
    } 
    else {
      content = isEditing ? (
        <input
          type={headerItem.input}
          name={headerItem.key}
          value={editedValues[headerItem.key] || ""}
          onChange={handleInputChange}
          onKeyDown={handleKeyDown}
          readOnly={headerItem.readOnly}
        />
      ) : Array.isArray(value)
      ? value.join(", ")
      : value ?? "";
    }
    
  
    if (isEditing) {
      return content;
    } else {
      if (headerItem.dataIcon) {
        const letter = content?.charAt(0)?.toUpperCase() || "N";
        return (
          <div className="d-flex align-items-center gap-2 reuseableEditable-avatar-circle-main">
            <div className={`reuseableEditable-avatar-circle ${title === "Holiday" ? "holiday-avater-color" : ""}`}>
              {letter}
            </div>
            {headerItem.highlightName ? (
              <span className="highlight-text">{content}</span>
            ) : (
              <span>{content}</span>
            )}
          </div>
        );
      } 
      else if (headerItem.highlightName) {
          return <span className="reuseableEditable-highlight-text">{content}</span>;
      } 
      else {
        return <span>{content}</span>;
      }
    }
    
  
  };
  
const submitdownload = async (data) => {
    setLoading(true);
    try {
        const response = await dispatch(globalDownloadAllSelectedIDsRecords(data));
        if (response.success == true) {
            showSnackbar(`Downloaded ${title} Successfully`, 'success');
            setLoading(false);
            setCheckedItems({})
        } else {
            showSnackbar(response.error, 'warning');
            setLoading(false);
        }
    } catch (error) {
        showSnackbar('An error occurred', 'error');
        setLoading(false);
    }
}
const handleDeleteSelected = () =>{
  if (checkedItemCount == 0) {
    showSnackbar("select the row", 'warning');
} else{
  setopendeletemultialert(true)
}
}
// const handleCheckAll = (e) => {
//   const checked = e.target.checked;
//   setIsAllChecked(checked);

//   const newCheckedItems = { ...checkedItems };
//   currentRecords.forEach((item) => {
//     newCheckedItems[item.id] = checked;
//   });

//   setCheckedItems(newCheckedItems);
// };
const handleCheckAll = (e) => {
  const checked = e.target.checked;

  setCheckedItems(prev => {
    const updated = { ...prev };

    currentRecords.forEach((item) => {
      updated[item.id] = checked;
    });

    return updated;
  });

  setIsAllChecked(checked);
};
// const updateCheckAllState = () => {
//     const allChecked = data?.length > 0 && data.every(item => checkedItems[item.id]);
//     setIsAllChecked(allChecked);
// };
// useEffect(() => {
//     updateCheckAllState();
//     const count = Object.values(checkedItems).filter(Boolean).length;
//     setCheckedItemCount(count);
// }, [checkedItems]);
const updateCheckAllState = () => {
    const allChecked =
        currentRecords?.length > 0 &&
        currentRecords.every(item => checkedItems[item.id]);

    setIsAllChecked(allChecked);
};
useEffect(() => {
    updateCheckAllState();
    const count = Object.values(checkedItems).filter(Boolean).length;
    setCheckedItemCount(count);
}, [checkedItems, currentRecords]);
const handleDownloadSelected = () =>{
    if (checkedItemCount == 0) {
      showSnackbar("select the row", 'warning');
  } else{
    const itemDatas = data;
    if(title == 'Branch Holidays') {
      const selectedIds = Object.keys(checkedItems).filter(id => checkedItems[Number(id)]).map(id => Number(id));
      let storedId = [];
      let storedHoliId = [];
      selectedIds.forEach(datas => {
          const item = itemDatas.find(d => d.id === datas);
          storedId.push(item.row_id);
          storedHoliId.push(item.old_id);
      });
  
      const client_id = sessionStorage.getItem('selectedClient')
      const data = {
          client_id: client_id,
          current_month: current_month,
          titleName: title,
          selectedIds: storedHoliId,
          ids: storedId
      }
      submitdownload(data);
    } else {
        const selectedIds = Object.keys(checkedItems).filter(id => checkedItems[Number(id)]).map(id => Number(id));
        const client_id = sessionStorage.getItem('selectedClient')
        const data = {
            client_id: client_id,
            current_month: current_month,
            titleName: title,
            selectedIds: selectedIds
        }
        submitdownload(data);
    }
  }
    
  }
  
  useEffect(() => {
    const checkScrollable = () => {
      if (containerRef.current) {
        const { scrollWidth, clientWidth } = containerRef.current;
        setIsScrollable(scrollWidth > clientWidth);
      }
    };

    checkScrollable(); // run once on mount
    window.addEventListener("resize", checkScrollable); // run on resize
    return () => window.removeEventListener("resize", checkScrollable);
  }, [data]);
  return (
    <div className={`container-fluid vendorEditableTable-main-contaner${title === "Vendor" ? " vendor-center-cells" : ""}`}>
      <div className='row FormsTable-main'>
          <div className="table-header">
            <div className="row d-flex">
                {/* <form onSubmit={handledeletemultialert} className='p-0 m-0'> */}
                  <div className="col d-flex justify-content-between  pe-1">
                    <div className="title-data d-flex"><div className="table_main_img"
                    //  style={{ backgroundColor: mainIconColor }} 
                    ><img src={mainIcon} alt="noImg" className='dataImg' /></div>
                      <p className="dataTitle">{title}</p> 
                      <div className="FormsTable-search-box position-relative">
                        <input
                          type="text"
                          className=""
                          placeholder="Search here..."
                          style={{
                            backgroundColor: "#f9fafb",
                            border: "none",
                            width: "250px"
                          }}
                          value={searchQuery}
                          onChange={(e) => setSearchQuery(e.target.value)}
                        />
                        <i
                          className="bi bi-search position-absolute"
                          style={{
                            top: "39%",
                            left: "20px",
                            transform: "translateY(-50%)",
                            color: "#9ca3af"
                          }}
                        ></i>
                      </div>
                    </div>
                    <div className='float-end d-flex'>             
                      {title !== "Vendor" &&
                      <button className='formsTable_icon_btn' onClick={handleDownloadSelected}><img src={download_icon} alt="noImg" className='download_icon p-0 m-0' /></button> }
                      {checkDelete === true && <button className='formsTable_icon_btn'  onClick={handleDeleteSelected}><img src={delete_icon} alt="noImg" className='delete_icon p-0 m-0' /></button> }
                      {/* <div className='formsTable_icon_btn'><img src={selected_icon} alt="" /></div>      */}
                        <div className="formsTable_icon_btn" onMouseEnter={() => setShowTooltip(true)} onMouseLeave={() => setShowTooltip(false)}>
                          <img src={selected_icon} alt="" />
                          {showTooltip && (
                              <div className="tooltipww">
                                  Selected: {checkedItemCount}
                              </div>
                          )}
                      </div>
                      <div className="dataTotalEntries"><p>Total Entries :{data?.length}</p></div>
                      {createOrfilterComp && <div className="filter_or_createcomponentn">
                        {createOrfilterComp}
                      </div>}  
                    </div>
                  </div>
                  {title === "Create Audit" && getCreatePermission && 
                    // <div className={`createAuditdiv d-flex justify-content-between ${actionClass ? actionClass : ""}`}>
                    //   <h5>Org.Name: <span>clinet name </span>Org.ID: <span>clinet name </span></h5>
                    //   <button className='createAudit' 
                    //   disabled={checkedItemCount === 0}
                    //   // title={checkedItemCount === 0 ? "Select at least one branch to create an audit" : ""}
                    //   onMouseEnter={() => setShowTooltip(true)} onMouseLeave={() => setShowTooltip(false)}
                    //   > + Create Audit</button>
                    //   {showTooltip && (
                    //           <div className="tooltipww">
                    //               "Select at least one branch to create an audit"
                    //           </div>
                    //       )}
                    // </div>
                    <div
                      className={`createAuditdiv d-flex justify-content-between ${actionClass ? actionClass : ""}`}
                    >

                      {/* <h5>
                        Org.Name: {clientName && <span> {clientName}</span>} &nbsp; Org.ID: {clientId && <span> {clientId}</span>}
                      </h5> */}
                      {filterAuditForm && filterAuditForm}

                      <div
                        className="createAuditWrapper position-relative"
                        onMouseEnter={() => setDesabledMsg(true)}
                        onMouseLeave={() => setDesabledMsg(false)}
                        onClick={() => {
                          if (checkedItemCount === 0) {
                            setDesabledMsg(true);
                            setTimeout(() => setDesabledMsg(false), 2000);
                          }
                        }}
                      >
                        <button
                          className="createAudit"
                          onClick={()=>{setCreateSingleAuditView(true)}}
                        >
                          + Create Audit
                        </button>
                      </div>
                    </div>

                  }
                    <div className="auditDetailsdiv">
                    </div>
                  <div className={`table-body bg-white p-0 ${title !=="Vendor" && 'table-roundedData'} ${actionClass ? actionClass : ""} `}>
                    <div
                     ref={containerRef}
                     className={`table-responsive reuseableEditable ${
                       isScrollable ? "is-scrollable-table" : ""
                     }`}
                    
                    >
                      <table className='table p-0 m-0' id='dataTable'>
                        <thead>
                          <tr>
                            <th style={{ backgroundColor: tableHeaderColor,color:tableHeaderTextColor }}><input type="checkbox" className='' name="" id=""  checked={isAllChecked} onChange={handleCheckAll}/></th>
                            <th style={{ backgroundColor: tableHeaderColor,color:tableHeaderTextColor }} className='slno'>
                              <img src={slno_icon} alt="noImg" className='headerIcon' />
                            SL No.</th>
                            {header?.map((headerItem) => (
                              <th style={{ backgroundColor: tableHeaderColor,color:tableHeaderTextColor ,cursor: "pointer" }}
                                  key={headerItem.key}
                                  onClick={() => handleSort(headerItem.key)}
                              >
                                <img src={headerItem.icon} alt="noImg" className='headerIcon' /> {headerItem.value === "Client ID"? "Org ID":headerItem.value} {getSortIcon(headerItem.key) &&<img src={getSortIcon(headerItem.key)} alt="" className='arrow_img'/>}
                              </th>
                            ))}
                            {checkEdit === true || checkDelete === true ? (
                              <th style={{ backgroundColor: tableHeaderColor,color:tableHeaderTextColor }} className='action_dataIconheader'><img src={action_icon} alt="noImg" className='headerIcon' />Action</th>
                            ) : (<></>)}
                          </tr>
                        </thead>
                        <tbody>
                          {currentRecords.length > 0 ? (
                            currentRecords.map((item, index) => (
                              <tr key={item.id} data-id={item.id}>
                                <td className="tabletdheight">
                                  <div className="table-td-div">
                                    <span>
                                    <input
                                      type="checkbox"
                                      className=''
                                      checked={checkedItems[item.id] || false}
                                      onChange={() => handleCheckChange(item.id)}
                                    />
                                    </span>
                                  </div>
                                </td>

                                <td className="tabletdheight slno" >
                                  <div className="table-td-div mt-1">
                                    {indexOfFirstRecord + index + 1}
                                  </div>
                                </td>

                                {header.map((headerItem) => (
                                  
                                  <td key={headerItem.key} className="tabletdheight">
                                    <div className="table-td-div">
                                      
                                      {renderCell(item, headerItem)}
                                    </div>
                                  </td>
                                ))}

                                {title === "Org. Details" && (
                                    <td className='text-center unitdata'>
                                        <a href={`unit-master/${item.client_id}`}>
                                            <i className="bi bi-file-plus cursor-pointer text-success auction-btn"></i>
                                        </a>
                                    </td>
                                )}
                                {(checkEdit || checkDelete) && (
                                  <td className="text-center action_dataIcon">
                                    {editableRow === item.id ? (
                                      <div className="d-flex justify-content-between">
                                        <span
                                          onClick={handleSavealert}
                                          className=" p-0"
                                        >
                                          <i className="bi bi-floppy2-fill text-success auction-btn" style={{ cursor:"pointer" }} ></i>
                                        </span>
                                        <span
                                          onClick={handleCancelClick}
                                          className=" p-0"
                                        >
                                          <i className="bi bi-x-circle text-info auction-btn" style={{ cursor:"pointer" }}></i>
                                        </span>
                                      </div>
                                    ) : (
                                      <div className="d-flex ">
                                        {checkEdit && (
                                          <span
                                            onClick={() => handleEditClick(item.id)}
                                            className=" p-0"
                                          >
                                            <div className="action_icon action_edit_icon"><img src={table_edit_icon} alt="" className='edit_icon'/></div>
                                          </span>
                                        )}
                                        {checkDelete && (
                                          <span
                                            onClick={() => handledeletealert(item.id)}
                                            className=" p-0"
                                          >
                                            <div className="action_icon action_delete_icon"><img src={table_delete_icon} alt="" className='delete_icon'/></div>
                                          </span>
                                        )}
                                      </div>
                                    )}
                                  </td>
                                )}
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td
                                colSpan={header.length + 2}
                                className="text-center fs-3 fw-bold text-muted"
                              >
                                {title === "Create Audit" && !clientId ? "Select The Organization Name" : "No Record Available"}
                              </td>
                            </tr>
                          )}
                        </tbody>

                      </table>
                    </div>
                    </div>
                  {/* </form> */}
              <div className="col-md-12">
              <div className="pagination align-items-center justify-content-between mt-3 row">
                <div className="col-md-12 text-center">
                <div>
                  {/* Prev button */}
                  <button
                    className="page-btn-arrow"
                    onClick={() => handlePageChange(currentPage - 1)}
                    disabled={currentPage === 1}
                  >
                    &lt;
                  </button>

                  {(() => {
                    const pages = [];

                    if (totalPages <= 10) {
                      // Show all pages if small count
                      for (let i = 1; i <= totalPages; i++) {
                        pages.push(i);
                      }
                    } else {
                      pages.push(1); // Always show first

                      // Left ellipsis
                      if (currentPage > 4) {
                        pages.push("...");
                      }

                      // Sliding window around current page
                      const start = Math.max(2, currentPage - 2);
                      const end = Math.min(totalPages - 1, currentPage + 2);

                      for (let i = start; i <= end; i++) {
                        pages.push(i);
                      }

                      // Right ellipsis
                      if (currentPage < totalPages - 3) {
                        pages.push("...");
                      }

                      pages.push(totalPages); // Always show last
                    }

                    return pages.map((p, idx) =>
                      p === "..." ? (
                        <span key={`ellipsis-${idx}`} className="ellipsis">
                          ...
                        </span>
                      ) : (
                        <button
                          key={p}
                          className={`page-btn ${currentPage === p ? "active" : ""}`}
                          onClick={() => handlePageChange(p)}
                        >
                          {p}
                        </button>
                      )
                    );
                  })()}

                  {/* Next button */}
                  <button
                    className="page-btn-arrow"
                    onClick={() => handlePageChange(currentPage + 1)}
                    disabled={currentPage === totalPages}
                  >
                    &gt;
                  </button>
                </div>

                </div>

                <div className="col-md-12">
                <div className="row float-end">
                <div className="d-flex align-items-center showPerPage">
                  <span className="me-2">Show per page:</span>
                  <select
                    value={recordsPerPage}
                    onChange={(e) => {
                      setRecordsPerPage(Number(e.target.value));
                      setCurrentPage(1);
                    }}
                  >
                    {getPageSizeOptions(sortedData.length).map((size, i) => (
                      <option key={i} value={size}>
                        {size === sortedData.length ? "All" : size}
                      </option>
                    ))}
                  </select>
                </div>
                </div>
                </div>
              </div>
              </div>

            </div>
          </div>
      </div>
      
      <Dialog
          open={openeditalert}
          TransitionComponent={Transition}
          keepMounted
          aria-describedby="alert-dialog-slide-description"
      >
          <DialogTitle>{"Are you sure?"}</DialogTitle>
          <DialogContent>
              <DialogContentText id="alert-dialog-slide-description">
                  Are you sure you want to edit this {title}? Any unsaved changes might be lost.
              </DialogContentText>
          </DialogContent>
          <DialogActions>
              <Button onClick={handleCloseeditalert}>No</Button>
              <Button onClick={handleSaveClickconfirmed}>Yes</Button>
          </DialogActions>
      </Dialog>
      <Dialog
          open={opendeletealert}
          TransitionComponent={Transition}
          keepMounted
          aria-describedby="alert-dialog-slide-description"
      >
          <DialogTitle>{"Are you sure?"}</DialogTitle>
          <DialogContent>
              <DialogContentText id="alert-dialog-slide-description">
                  Are you sure you want to delete this {title}? This action cannot be undone.

              </DialogContentText>
          </DialogContent>
          <DialogActions>
              <Button onClick={handledeleteClosealert}>No</Button>
              <Button onClick={handledeleteClickconfirmed}>Yes</Button>
          </DialogActions>
      </Dialog>
      <Dialog
          open={opendeletemultialert}
          TransitionComponent={Transition}
          keepMounted
          aria-describedby="alert-dialog-slide-description"
      >
          <DialogTitle>{"Are you sure?"}</DialogTitle>
          <DialogContent>
              <DialogContentText id="alert-dialog-slide-description">
                  Are you sure you want to delete those {title}? This action cannot be undone.

              </DialogContentText>
          </DialogContent>
          <DialogActions>
              <Button onClick={handledeletemultiClosealert}>No</Button>
              <Button onClick={selectedDelete}>Yes</Button>
          </DialogActions>
      </Dialog>
    </div>
  )
}

export default Editble_table